import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Screen from '../screen'

const screen = new Screen()
gsap.registerPlugin(ScrollTrigger)

const animateSolution = () => {
  const timelineSolution = gsap.timeline({
    scrollTrigger: {
      trigger: '#solution',
      pin: true,
      scrub: 1,
      end: '+600%',
    },
  })

  const duration = 4

  timelineSolution
    .set(['.js-solution01', '.js-solution02', '.js-solution03', '.js-solution04'], {
      xPercent: '-50',
      yPercent: '-50',
      y:0,
      x:0,
    })
    .addLabel('init')
    .set('.js-solution02', {
      scale: 0.5,
      opacity: 0,
      xPercent: '-90',
      yPercent: '-30',
      zIndex: 9,
    })
    .set(
      [
        '.js-solution02 .heading__jp',
        '.js-solution03 .heading__jp',
        '.js-solution04 .heading__jp',
        '.js-solution04 .solution__button',
      ],
      {
        opacity: 0,
        visibility: 'hidden',
      }
    )
    .set('.js-solution03', {
      opacity: 0,
      scale: 0.4,
      yPercent: '-40',
      zIndex: 8,
    })
    .set('.js-solution04', {
      opacity: 0,
      scale: 0.4,
      yPercent: '-10',
    })
    .set('.js-solution04 .heading', {
      zIndex: 7,
    })
    .addLabel('scene01')
    .to(
      '.js-solution01 ',
      {
        opacity: 1,
        scale: 2,
        duration,
        force3D: false,
      },
      duration
    )
    .to(
      '.js-solution01 ',
      {
        scale: 10,
        xPercent: '-120',
        yPercent: '290',
        duration,
        force3D: false,
      },
      duration * 2
    )
    .to(
      '.js-solution01',
      {
        scale: 25,
        xPercent: '-90',
        yPercent: screen.isPC ? '965' : '1014',
        duration,
        force3D: false,
      },
      duration * 3
    )
    .to(
      '.js-solution01',
      {
        scale: 35,
        xPercent: '-57',
        yPercent: screen.isPC ? '1350' : '1431',
        duration,
        force3D: false,
      },
      duration * 4
    )
    .to(
      '.js-solution01',
      {
        scale: 80,
        xPercent: '-70',
        yPercent: screen.isPC ? '3200' : '3330',
        duration,
        force3D: false,
      },
      duration * 5
    )
    .to(
      '.js-solution01',
      {
        scale: 100,
        xPercent: '-80',
        yPercent: screen.isPC ? '4000' : '4180',
        opacity: 0,
        duration,
        force3D: false,
      },
      duration * 6
    )
    .addLabel('scene02')
    .to(
      '.js-solution02',
      {
        opacity: 1,
        duration,
        force3D: false,
      },
      duration * 4
    )
    .to(
      '.js-solution02',
      {
        xPercent: '-50',
        duration,
        force3D: false,
      },
      duration * 4
    )
    .to(
      '.js-solution02',
      {
        scale: 1,
        duration,
        force3D: false,
      },
      duration * 5
    )
    .to(
      '.js-solution02',
      {
        yPercent: '-50',
        duration,
      },
      duration * 6
    )
    .to(
      '.js-solution02 .heading__jp',
      {
        visibility: 'visible',
        autoAlpha: 1,
        duration,
      },
      duration * 6
    )
    .to(
      '.js-solution02 ',
      {
        opacity: 1,
        scale: 2,
        duration,
        force3D: false,
      },
      duration * 7
    )
    .to(
      '.js-solution02 ',
      {
        scale: 10,
        xPercent: screen.isPC ? '-204' : '212',
        yPercent: screen.isPC ? '290' : '140',
        duration,
        force3D: false,
      },
      duration * 8
    )
    .to(
      '.js-solution02',
      {
        scale: screen.isPC ? 40 : 30,
        xPercent: screen.isPC ? '-325' : '826',
        yPercent: screen.isPC ? '1565' : '780',
        duration,
        force3D: false,
      },
      duration * 9
    )
    .to(
      '.js-solution02',
      {
        scale: screen.isPC ? 100 : 50,
        xPercent: screen.isPC ? '-722' : '1411',
        yPercent: screen.isPC ? '3880' : '1330',
        duration,
        force3D: false,
      },
      duration * 11
    )
    .to(
      '.js-solution02',
      {
        scale: screen.isPC ? 150 : 80,
        xPercent: screen.isPC ? '-1070' : '2300',
        yPercent: screen.isPC ? '6020' : '2126',
        opacity: 0,
        duration,
        force3D: false,
      },
      duration * 12
    )
    .addLabel('scene03')
    .to(
      '.js-solution03',
      {
        opacity: 1,
        delay: 1,
        duration,
      },
      duration * 9
    )
    .to(
      '.js-solution03',
      {
        scale: 1,
        duration,
        force3D: false,
      },
      duration * 11
    )
    .to(
      '.js-solution03',
      {
        yPercent: '-50',
        duration,
        force3D: false,
      },
      duration * 12
    )
    .to(
      '.js-solution03 .heading__jp',
      {
        visibility: 'visible',
        autoAlpha: 1,
        duration,
      },
      duration * 12
    )
    .to(
      '.js-solution03',
      {
        scale: 2,
        duration,
        force3D: false,
      },
      duration * 13
    )
    .to(
      '.js-solution03',
      {
        scale: 15,
        xPercent: screen.isPC ? '-300' : '83',
        yPercent: screen.isPC ? '520' : '431',
        duration,
        force3D: false,
      },
      duration * 14
    )
    .to(
      '.js-solution03',
      {
        scale: 30,
        xPercent: screen.isPC ? '-440' : '234',
        yPercent: screen.isPC ? '1150' : '935',
        duration,
        force3D: false,
      },
      duration * 15
    )
    .to(
      '.js-solution03',
      {
        scale: 60,
        xPercent: screen.isPC ? '-815' : '506',
        yPercent: screen.isPC ? '2240' : '1880',
        duration,
        force3D: false,
      },
      duration * 17
    )
    .to(
      '.js-solution03',
      {
        scale: screen.isPC ? 120 : 90,
        xPercent: screen.isPC ? '-1540' : '730',
        yPercent: screen.isPC ? '4560' : '2800',
        opacity: 0,
        duration,
        force3D: false,
      },
      duration * 18
    )
    .addLabel('scene04')
    .to(
      '.js-solution04',
      {
        opacity: 1,
        duration,
      },
      duration * 16
    )
    .to(
      '.js-solution04',
      {
        scale: 1,
        duration,
        force3D: false,
      },
      duration * 17
    )
    .to(
      '.js-solution04',
      {
        yPercent: '-50',
        y: '120px',
        duration,
        force3D: false,
      },
      duration * 18
    )
    .to(
      '.js-solution04 .heading__jp',
      {
        opacity: 1,
        visibility: 'visible',
        duration,
      },
      duration * 18
    )
    .to(
      '.js-solution04',
      {
        y: 0,
        duration,
        force3D: false,
      },
      duration * 19
    )
    .to(
      '.js-solution04 .solution__button',
      {
        opacity: 1,
        visibility: 'visible',
        duration,
      },
      duration * 19
    )
    .to(
      '.js-solution04',
      {
        duration,
      },
      duration * 20
    )
}

export default animateSolution
